module.exports = __webpack_public_path__ + "media/images/restaurant/logo_diners-8c7805b52ff3a61cb65d485a4ae4d4a7.png";